import(/* webpackMode: "eager", webpackExports: ["ArticlePage"] */ "/home/ubuntu/shipsmart/apps/admin/src/app/shared/landing/pages/news/article-page.tsx");
